import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { makeTextStyleSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { makeFieldStyleSelector } from "../selectors";
import { createAnswer, updateAnswer } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import {
  localStateSelector,
  makeAnswersSelector,
  makeQuestionsSelector,
  makeSeparatorStyleSelector
} from "./selectors";

const makeMapStateToProps = () => {
  const questionsSelector = makeQuestionsSelector();
  const answersSelector = makeAnswersSelector();
  const fieldStyleSelector = makeFieldStyleSelector();
  const labelStyleSelector = makeTextStyleSelector(TargetSelector.Entity, "label");
  const separatorStyleSelector = makeSeparatorStyleSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      questions: questionsSelector(state, props),
      answers: answersSelector(state, props),
      isEditMode: state.isEditMode,
      fieldStyle: fieldStyleSelector(state, props),
      labelStyle: labelStyleSelector(state, props),
      separatorStyle: separatorStyleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onCreateAnswer: (item) =>
    dispatch(createAnswer(getEntityRef(props), item.rating, item.ticketFeedbackQuestionId, item.answer)),
  onUpdateAnswer: (item) =>
    dispatch(updateAnswer(getEntityRef(props), item.rating, item.ticketFeedbackQuestionId, item.answer))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
